import { getAuthAxiosBackend } from "../helpers/axios"

class QuotationServices{

    constructor(){
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('quotation', {params: data})
    }

    edit(id, quotation){
        quotation.append('_method', 'put')
        return getAuthAxiosBackend().post('quotation' + '/' + id, quotation)
    }
}

export default new QuotationServices()